import { render, staticRenderFns } from "./Kayttaja.vue?vue&type=template&id=ba25235a&"
import script from "./Kayttaja.vue?vue&type=script&lang=js&"
export * from "./Kayttaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports